/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector, change, getFormValues } from 'redux-form';
import isEqual from 'lodash/isEqual';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import { getSiteId, isClient } from '@tcp/core/src/utils';
import { readCookie } from '@tcp/core/src/utils/cookie.util';
import { getAddressLocationInfo } from '@tcp/core/src/utils/addressLocation.js';
import { getSlpProducts } from '@tcp/core/src/components/features/browse/SearchDetail/container/SearchDetail.actions';
import { resetStoresByCoordinates } from '@tcp/core/src/components/features/storeLocator/StoreLanding/container/StoreLanding.actions';
import submitProductListingFiltersForm from '@tcp/core/src/components/features/browse/ProductListing/container/productListingOnSubmitHandler';
import { getLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import CheckoutSelector from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.selector';
import { getEddData } from '@tcp/core/src/components/features/CnC/common/molecules/EddComponent/container/EddComponent.selectors';
import { getModalState } from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.selectors';
import { PRODUCT_PICKUP_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';
import { compose } from 'redux';
import ProductPickup from '../views/ProductPickup.view';
import {
  getBopisInventoryDetailsAction,
  fromAvailableStoresClick,
  setFromRecommQVActn,
  getStoreSpecificInventoryAction,
} from './ProductPickup.actions';
import * as PickupModalSelectors from '../../PickupStoreModal/container/PickUpStoreModal.selectors';
import { distancesMap } from '../../PickupStoreModal/PickUpStoreModal.config';

import * as PickupSelectors from './ProductPickup.selectors';
import {
  getIsBossEnabled,
  getIsBopisEnabled,
  getIsRadialInventoryEnabled,
  getIsVMPBossEnabled,
  getIsShowShipToHomeEddEnabled,
  getIsFBTShowEnabled,
  getBopisMultipleStoreEnabled,
  getStoreSearchTypesParam,
  getBossMultipleStoreEnabled,
  getIsPickupPromotionPDPEnabled,
  getIsDynamicFreeShippingEnabled,
  getDynamicShippingCharge,
  getIsDisplayPickupTimeEnabled,
  getStoreHoursThreshold,
  getIsFullDateDisplayEnabled,
  getIsBopisPromotionDiscountEnabled,
  getShowBopisTileBasedOnStoreSpecials,
  allowOnlineProductPickup,
  getIsFreeShippingOnFulfillmentTileEnabled,
} from '../../../../../reduxStore/selectors/session.selectors';
import {
  validateSkuDetails,
  validateBossEligibility,
  validateBopisEligibility,
  isBOSSProductOOS,
  isProductOOS,
  numericStringToBool,
  isVariantHasPreOrder,
} from '../util';
import {
  getBopisStoresActn,
  openPickupModalWithValues,
} from '../../PickupStoreModal/container/PickUpStoreModal.actions';
import {
  getVariantId,
  getMapSliceForSize,
  getIsOnlineExclusive,
  getSkuId,
} from '../../../../features/browse/ProductListing/molecules/ProductList/utils/productsCommonUtils';
import {
  COLOR_FITS_SIZES_MAP_PROP_TYPE,
  PRICING_PROP_TYPES,
} from '../../PickupStoreModal/PickUpStoreModal.proptypes';
import { getIsPickupModalOpen } from '../../PickupStoreModal/container/PickUpStoreModal.selectors';
import { getUserNearStore } from '../../../../features/account/User/container/User.selectors';
import { trackClick, setClickAnalyticsData } from '../../../../../analytics/actions';
import { getSelectedAccessories } from '../../../molecules/Accessories/container/Accessories.selectors';
import { getTheme } from '../../../../../utils/utils';
import ProductPickupStoreSaga from './ProductPickup.saga';
import ProductPickupReducer from './ProductPickup.reducer';
import PickupStoreModalSaga from '../../PickupStoreModal/container/PickUpStoreModal.saga';
import { getLabelFromCopyOrFromTranslation } from '../../../../../utils/labels/labelUtilty';
import { ProductPickupLabels } from '../../../../../utils/labels/browse/ProductPickup.labels';
import { getFreeShippingThresholdValue } from '../../../../features/CnC/BagPage/container/BagPage.selectors';

/**
 *  Describes a general product, not yet specialized by chosing a color, size, etc.
 *  For example, a product shown in reccomendations, or PDP.
 */
export const PRODUCT_INFO_PROP_TYPES = {
  /* this identifies a product for Bazaarvoice (reviews and ratings component) */
  ratingsProductId: PropTypes.string,

  /** This identifies the product regardless of color/fit/size (i.e., changing size/fit/color does not change this value) */
  generalProductId: PropTypes.string.isRequired,
  /** The name of the product to be displayed to the user */
  name: PropTypes.string.isRequired,
  /** Images for this product in different colors.
   * This is an object of key-vale pairs. the key is the color name, and the value has thew shape described below.
   */
  imagesByColor: PropTypes.oneOfType([
    PropTypes.objectOf(
      PropTypes.shape({
        extraImages: PropTypes.arrayOf(
          PropTypes.shape({
            iconSizeImageUrl: PropTypes.string.isRequired,
            regularSizeImageUrl: PropTypes.string.isRequired,
            bigSizeImageUrl: PropTypes.string.isRequired,
            superSizeImageUrl: PropTypes.string.isRequired,
          })
        ),
      })
    ),
    PropTypes.objectOf(
      PropTypes.shape({
        basicImageUrl: PropTypes.string.isRequired,
      })
    ),
  ]),
  /** optional displayNames of the color fit and size (e.g., for gift cards it is {color: 'Design, size: 'Value']) */
  colorFitSizeDisplayNames: PropTypes.shape({
    color: PropTypes.string,
    fit: PropTypes.string,
    size: PropTypes.string,
  }),
  /**
   * The available color fit and size options for this product
   * Organized in a three level nesting (similar to a site navigation) with L1 being the color,
   * L2 being the fit, and L3 being the size
   */
  colorFitsSizesMap: COLOR_FITS_SIZES_MAP_PROP_TYPE,

  /** SEO Friendly URL required to have the image and title linkable */
  pdpUrl: PropTypes.string.isRequired,

  /* Short description of the product. */
  shortDescription: PropTypes.string,

  /* Long description of the product that may include HTML. */
  longDescription: PropTypes.string,

  /** Flags if this SKU/product is a Gift-Card */
  isGiftCard: PropTypes.bool,

  /** Product price, which may be overriden by sku-level price */
  ...PRICING_PROP_TYPES,
};

export const PRODUCT_INFO_PROP_TYPE_SHAPE = PropTypes.shape(PRODUCT_INFO_PROP_TYPES);

const updateItemValueObj = (itemObjParam) => {
  const itemObj = itemObjParam;
  const itemObjKeys = Object.keys(itemObj);
  itemObjKeys.forEach((objKey) => {
    if (itemObj[objKey] && itemObj[objKey].name) {
      itemObj[objKey] = itemObj[objKey].name;
    }
  });
  return itemObj;
};
class ProductPickupContainer extends React.PureComponent {
  static propTypes = {
    miscInfo: PropTypes.shape({}),
    /**
     * Information regarding the product at the swatch/color level.
     */
    productInfo: PRODUCT_INFO_PROP_TYPE_SHAPE.isRequired,
    /** User's preferred store information */
    userDefaultStore: PropTypes.shape({
      basicInfo: PropTypes.shape({
        /** store id identifier */
        id: PropTypes.string.isRequired,
        /** store Name */
        storeName: PropTypes.string.isRequired,
      }).isRequired,
      storeBossInfo: PropTypes.shape({
        isBossEligible: PropTypes.bool,
      }),
    }),
    /**
     * User's latitude and longitude coordinates if access is allowed.
     */
    userGeoCoordinates: PropTypes.shape({
      lat: PropTypes.number,
      long: PropTypes.number,
    }),

    /**
     * Item values selected for the product, to use in the BOPIS modal if it
     * gets opened.
     */
    itemValues: PropTypes.shape({
      color: PropTypes.string.isRequired,
      Fit: PropTypes.string,
      Size: PropTypes.string,
      quantity: PropTypes.number,
    }),

    /**
     * method responsible for triggering the operator method for BopisQuickViewModal
     */
    onPickUpOpenClick: PropTypes.func,
    /**
     * carries the inventory information of the bopis item selected
     */
    bopisItemInventory: PropTypes.arrayOf(PropTypes.object),
    isBossEnabled: PropTypes.bool,
    isBopisEnabled: PropTypes.bool,
    isBopisClearanceProductEnabled: PropTypes.bool,
    isBossClearanceProductEnabled: PropTypes.bool,
    getBopisInventoryDetails: PropTypes.func.isRequired,
    getGeoDefaultStore: PropTypes.func,
    itemBrand: PropTypes.string,
    isRadialInventoryEnabled: PropTypes.bool,
    simplifiedProductPickupView: PropTypes.bool,
    isAnchor: PropTypes.bool,
    sizeUnavailable: PropTypes.string,
    onPickupClickAddon: PropTypes.func,
    isOutfitVariant: PropTypes.bool,
    keepAlive: PropTypes.bool,
    outOfStockLabels: PropTypes.shape({}),
    promotionalMessage: PropTypes.string,
    promotionalPLCCMessage: PropTypes.string,
    availableTCPmapNewStyleId: PropTypes.shape([]),
    initialMultipackMapping: PropTypes.shape([]),
    setInitialTCPStyleQty: PropTypes.string,
    isNewQVEnabled: PropTypes.bool,
    onCloseClick: PropTypes.func.isRequired,
    currentColorEntry: PropTypes.shape({}),
    productInfoFromBag: PropTypes.shape({}).isRequired,
    fromBagPage: PropTypes.bool.isRequired,
    pdpUrlFromBag: PropTypes.string,
    pickupSelectionUpdate: PropTypes.func,
    isPickUpSelected: PropTypes.string,
    isNewReDesignFullfilmentSection: PropTypes.bool,
    initialValues: PropTypes.shape({
      size: PropTypes.string,
    }),
    noBossBopisInfoSendToPDP: PropTypes.func,
    isNewPDPEnabled: PropTypes.bool,
    checkForOOSForVariant: PropTypes.bool.isRequired,
    isAllSizeDisabled: PropTypes.bool,
    alternateBrand: PropTypes.string,
    selectDeliveryType: PropTypes.func,
    showSizeError: PropTypes.func,
    userNearByStore: PropTypes.shape([]),
    selectedAccessories: PropTypes.shape([]),
    isPDPBossBopisEnabled: PropTypes.bool,
    isBossBopisPDPSizeDrawer: PropTypes.bool,
    currentSelectedPickUpType: PropTypes.string,
    trackClickAction: PropTypes.func.isRequired,
    isNewPJPPDPRedesignEnabled: PropTypes.bool,
    autoSkipStep1: PropTypes.bool,
    isBopisPromoDiscountBannerEnabled: PropTypes.bool,
  };

  static defaultProps = {
    miscInfo: {},
    userDefaultStore: {
      basicInfo: {
        id: '',
        storeName: '',
      },
      storeBossInfo: {
        isBossEligible: false,
      },
    },
    userGeoCoordinates: {
      lat: null,
      long: null,
    },
    itemValues: {
      color: '',
      fit: '',
      size: '',
      quantity: null,
    },
    onPickUpOpenClick: null,
    bopisItemInventory: [],
    isBossEnabled: false,
    isBopisEnabled: false,
    itemBrand: '',
    isBopisClearanceProductEnabled: false,
    isBossClearanceProductEnabled: false,
    getGeoDefaultStore: () => {},
    isRadialInventoryEnabled: false,
    simplifiedProductPickupView: false,
    isAnchor: false,
    sizeUnavailable: 'Size unavailable online?',
    onPickupClickAddon: () => {},
    isOutfitVariant: false,
    keepAlive: false,
    outOfStockLabels: {},
    promotionalMessage: '',
    promotionalPLCCMessage: '',
    availableTCPmapNewStyleId: [],
    initialMultipackMapping: [],
    setInitialTCPStyleQty: '',
    isNewQVEnabled: false,
    currentColorEntry: {},
    pdpUrlFromBag: '',
    pickupSelectionUpdate: () => {},
    isPickUpSelected: '',
    isNewReDesignFullfilmentSection: false,
    initialValues: {
      size: '',
    },
    noBossBopisInfoSendToPDP: () => {},
    isNewPDPEnabled: false,
    isAllSizeDisabled: false,
    userNearByStore: [],
    selectedAccessories: [],
    alternateBrand: '',
    selectDeliveryType: () => {},
    showSizeError: () => {},
    isPDPBossBopisEnabled: false,
    isBossBopisPDPSizeDrawer: false,
    currentSelectedPickUpType: 'shipIt',
    isNewPJPPDPRedesignEnabled: false,
    autoSkipStep1: false,
    isBopisPromoDiscountBannerEnabled: false,
  };

  constructor(props, context) {
    super(props, context);
    const {
      miscInfo,
      isBossEnabled,
      isBopisEnabled,
      isBopisClearanceProductEnabled,
      isBossClearanceProductEnabled,
      initialValues,
      isNewReDesignFullfilmentSection,
    } = props;
    const bossValidatingParams = {
      isBossClearanceProductEnabled,
      isBossEnabled,
    };
    const bopisValidatingParams = {
      isBopisClearanceProductEnabled,
      isBopisEnabled,
    };
    this.isSkuResolved = false;
    this.isBopisEligible = validateBopisEligibility({ ...bopisValidatingParams, miscInfo });
    this.isBossEligible = validateBossEligibility({ ...bossValidatingParams, miscInfo });
    this.isGeoStoreAPIRequested = false;
    this.state = {
      isSubmitting: false,
      bopisWithAccessory: false,
      isCalled: true,
      isBossCalled: false,
    };
    if (isNewReDesignFullfilmentSection) this.initialValues = initialValues;
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  componentDidUpdate(prevProps, prevState) {
    const {
      userDefaultStore,
      productInfo,
      itemValues,
      getBopisInventoryDetails,
      getStoreSpecificIventory,
      userGeoCoordinates: { lat, long },
      getGeoDefaultStore,
      isBossClearanceProductEnabled,
      isBossEnabled,
      isBopisClearanceProductEnabled,
      isBopisEnabled,
      miscInfo,
      isNewReDesignFullfilmentSection,
      currentSelectedPickUpType,
      isBossBopisPDPSizeDrawer,
      getBopisStores,
      isBopisMultipleStoreEnabled,
      fromAvailableStoresClickMethod,
      isPickUpSelected,
      storeIdList,
      isQVModalOpen,
      isPDP,
      isFromPDP,
      isQuickView,
      setFromRecommQV,
      allBopisStores,
      isPickupPromotionPDPEnabled,
      isStoreSpecialsPriceOn,
      storeSpecials,
      currentColorEntry,
      shouldAllowOnlineProductPickup,
    } = this.props;

    const { colorProductId } = currentColorEntry || {};
    const { colorProductId: prevColorProductId } = prevProps?.currentColorEntry || {};

    const bossValidatingParams = {
      isBossClearanceProductEnabled,
      isBossEnabled,
    };
    const bopisValidatingParams = {
      isBopisClearanceProductEnabled,
      isBopisEnabled,
    };
    const isDefaultBadge = getIsOnlineExclusive(miscInfo);

    this.isBopisEligible = this.calculateBopisEligibility(
      isStoreSpecialsPriceOn,
      storeSpecials,
      bopisValidatingParams,
      miscInfo,
      isDefaultBadge,
      shouldAllowOnlineProductPickup
    );

    this.isBossEligible = validateBossEligibility({ ...bossValidatingParams, miscInfo });
    this.isGeoStoreAPIRequested = false;

    this.updateBossMultiStoreAnalyticsState(prevProps);

    if (this.shouldWeCallAPIToGetInventoryDetails(prevProps, prevState)) {
      // Added New check for userDefaultStore to fire getBopisInventoryDetails when user has already selected sku and allows location access later.
      const itemPartNumber = getVariantId(
        productInfo.colorFitsSizesMap,
        itemValues.color,
        itemValues.Fit,
        itemValues.Size
      );
      const currentSizeEntry = getMapSliceForSize(
        productInfo.colorFitsSizesMap,
        itemValues.color,
        itemValues.Fit,
        itemValues.Size
      );
      const skuId = getSkuId(
        productInfo?.colorFitsSizesMap,
        itemValues.color,
        itemValues.Fit,
        itemValues.Size
      );
      const variantNo =
        currentSizeEntry && currentSizeEntry.variantNo ? currentSizeEntry.variantNo : null;
      const isPDPPage = isPDP || isFromPDP;
      const isRecommendationsQV = this.checkRecommQV(
        isQuickView,
        this.checkPdpOnWeb(isPDPPage),
        isBopisMultipleStoreEnabled
      );

      const itemInfo = [
        {
          storeId: this.checkStoreID(
            storeIdList,
            userDefaultStore,
            allBopisStores,
            isRecommendationsQV
          ),
          variantNo,
          itemPartNumber,
        },
      ];
      if (
        (!this.noBossBopisInfo() &&
          isNewReDesignFullfilmentSection &&
          (isBossBopisPDPSizeDrawer || currentSelectedPickUpType === 'pickItUp')) ||
        !isNewReDesignFullfilmentSection
      ) {
        setFromRecommQV(isRecommendationsQV);
        this.checkAndUpdateStoreInventory({
          prevProps,
          userDefaultStore,
          productInfo,
          getStoreSpecificIventory,
          isPickupPromotionPDPEnabled,
        });
        getBopisInventoryDetails({
          itemInfo,
          isMultiStoreEnabled: this.isMultiStoreEnabled(
            isQVModalOpen,
            isPDPPage,
            isBopisMultipleStoreEnabled
          ),
          isRecommendationsQV,
          requestedQuantity: itemValues?.Quantity,
        });

        if (
          this.checkToMakeStoreCall(
            isBopisMultipleStoreEnabled,
            storeIdList,
            allBopisStores,
            isRecommendationsQV,
            prevColorProductId,
            colorProductId
          )
        ) {
          fromAvailableStoresClickMethod(true);
          const fetchPayload = this.fetchStorePayload();
          fetchPayload.variantId = itemPartNumber;
          fetchPayload.variantNo = variantNo;
          fetchPayload.skuId = skuId;
          fetchPayload.quantity = itemValues?.Quantity;
          fetchPayload.nearestStoreUpdateFlag = true;
          fetchPayload.currentSelectedPickUpTypeOnPDP = isPickUpSelected;
          fetchPayload.isRecommendationsQV = isRecommendationsQV;
          getBopisStores(fetchPayload);
          this.setState({ isCalled: false });
        }
      }
    } else if (!userDefaultStore && lat && long && !this.isGeoStoreAPIRequested) {
      /* Making this call only when preffered store doesn't exist in redux state and lat long are changed by user's access.
       * Added isGeoStoreAPIRequested to ensure that API for geo store is called only once
       * (It was being called multiple times when no store is returned in response)
       * isGeoStoreAPIRequested - was used instead of comparing previous Lat/Long of props to handle edge case when
       * guest user visits site for 2nd time (1st time allows access to geo loc).
       * as fav store api for guest login is not being consumed;
       * In this case, default store API was never being called as prev lat/long == new lat/long.
       */
      this.isGeoStoreAPIRequested = true;
      getGeoDefaultStore();
    }
    this.handlePickUpScenarios(prevProps);
  }

  checkAndUpdateStoreInventory = ({
    prevProps,
    userDefaultStore,
    productInfo,
    getStoreSpecificIventory,
    isPickupPromotionPDPEnabled,
  }) => {
    if (
      prevProps?.userDefaultStore?.basicInfo?.id !== userDefaultStore?.basicInfo?.id &&
      isPickupPromotionPDPEnabled
    ) {
      getStoreSpecificIventory?.({
        storeId: userDefaultStore?.basicInfo?.id,
        productId: productInfo?.generalProductId,
        brand: productInfo?.primaryBrand,
      });
    }
  };

  checkStoreID = (storeIdList, userDefaultStore, allBopisStores, isRecommendationsQV) => {
    let stores = [];
    const checkStoreIDList = this.checkStoreIDList(storeIdList, allBopisStores);
    if (storeIdList?.length !== 0) {
      stores = storeIdList;
    } else if (checkStoreIDList?.length > 0 && isRecommendationsQV) {
      stores = checkStoreIDList;
    } else {
      stores = userDefaultStore?.basicInfo?.id;
    }
    return stores;
  };

  checkStoreIDList = (storeIdList, allBopisStores) => {
    const arr = [];
    if (storeIdList?.length === 0 && allBopisStores?.length > 0) {
      allBopisStores?.forEach((store) => {
        arr.push(store?.basicInfo?.id);
      });
    }
    return arr;
  };

  checkToMakeStoreCall = (
    isBopisMultipleStoreEnabled,
    storeIdList,
    allBopisStores,
    isRecommendationsQV,
    prevColorProductId,
    colorProductId
  ) => {
    if (isRecommendationsQV) {
      return (
        isBopisMultipleStoreEnabled && storeIdList?.length === 0 && allBopisStores?.length === 0
      );
    }
    return (
      isBopisMultipleStoreEnabled &&
      (storeIdList?.length === 0 || prevColorProductId !== colorProductId)
    );
  };

  isMultiStoreEnabled = (isQVModalOpen, isPDP, isBopisMultipleStoreEnabled) => {
    return (isQVModalOpen || isPDP) && isBopisMultipleStoreEnabled;
  };

  checkPdpOnWeb = (isPDPPage) =>
    isClient() ? window?.location?.pathname?.indexOf('/p/') !== -1 : isPDPPage;

  checkRecommQV = (isQVModalOpen, isPDP, isBopisMultipleStoreEnabled) => {
    return isQVModalOpen && isPDP && isBopisMultipleStoreEnabled;
  };

  getBossEligBossInvAvail = (isStoreBossEligible, isbossInventoryAvailable) => {
    return isStoreBossEligible && this.isBossEligible && isbossInventoryAvailable;
  };

  getIsStoreBopisEligible = (bopisItemInventory) => {
    return (
      this.isBopisEligible &&
      bopisItemInventory &&
      bopisItemInventory.inventoryResponse &&
      bopisItemInventory.inventoryResponse.length > 0 &&
      bopisItemInventory.inventoryResponse[0].quantity > 0
    );
  };

  getIsStoreAndProductBossEligibleWithInventory = (
    isBOSSInventoryAvailable,
    isStoreAndProductBossEligible
  ) => {
    return isBOSSInventoryAvailable && isStoreAndProductBossEligible;
  };

  getIsStoreAndProductBossEligible = (isStoreBossEligible) => {
    return isStoreBossEligible && this.isBossEligible;
  };

  /**
   * @method setPickupTitle
   * @param {object} miscInfo carries the information of the product with
   * respective color product
   * @param {object} userDefaultStore carries the information of the store user's
   * default store
   */
  setPickupTitle() {
    const { userDefaultStore, productInfo, itemValues, isRadialInventoryEnabled } = this.props;
    let isStoreBossEligible = false;
    if (userDefaultStore) {
      isStoreBossEligible = numericStringToBool(
        userDefaultStore.storeBossInfo && userDefaultStore.storeBossInfo.isBossEligible
      );
    }

    let isbossInventoryAvailable;
    if (isRadialInventoryEnabled) {
      // kill switch RAD-171 RAD-74
      isbossInventoryAvailable = !isBOSSProductOOS(productInfo.colorFitsSizesMap, itemValues);
    } else {
      isbossInventoryAvailable = !isProductOOS(productInfo.colorFitsSizesMap, itemValues); // RAD-171 RAD-74 to behave like production in case kill switch is off.
    }
    const isBossEligBossInvAvail = this.getBossEligBossInvAvail(
      isStoreBossEligible,
      isbossInventoryAvailable
    );
    let showChangeStore = false;
    let pickupTitleText = getLabelFromCopyOrFromTranslation(
      'lbl_Product_pickup_TITLE_DEFAULT_NOSTORE',
      ProductPickupLabels
    );
    if (this.isSkuResolved) {
      if (userDefaultStore) {
        if (isBossEligBossInvAvail || this.isBopisEligible) {
          showChangeStore = true;
        }
        pickupTitleText = getLabelFromCopyOrFromTranslation(
          'lbl_Product_pickup_TITLE_DEFAULT_NOSTORE',
          ProductPickupLabels
        );
        return { showChangeStore, pickupTitleText, isBossEligBossInvAvail };
      }
      if (this.isBopisEligible && !isBossEligBossInvAvail) {
        // bopis only
        /**
         * @returns if the product is only bopis eligible and the sku is resolved
         * then it @returns {labels?.PRODUCT_BOPIS}
         */
        pickupTitleText = getLabelFromCopyOrFromTranslation(
          'lbl_Product_pickup_TITLE_DEFAULT_NOSTORE',
          ProductPickupLabels
        );
        return { showChangeStore, pickupTitleText, isBossEligBossInvAvail };
      }
      pickupTitleText = getLabelFromCopyOrFromTranslation(
        'lbl_Product_pickup_TITLE_DEFAULT_NOSTORE',
        ProductPickupLabels
      );
      return { showChangeStore, pickupTitleText, isBossEligBossInvAvail };
    }
    return { showChangeStore, pickupTitleText, isBossEligBossInvAvail };
  }

  /**
   * @member getPickupInfo
   * @description this method returns the information of pickup on the
   * respective store based on different scenarios
   * @param {object} miscInfo carries the product information
   * with respective color id
   * @param {object} userDefaultStore carries the information of User's default store
   * @return if the sku is resolved and the product is available in store
   * or both BOSS and BOPIS
   * then is @returns - item availability information along with the
   * pickup today label and the BOSS dates information with the boss pickup
   * label
   * @return if the sku is resolved and the product is only available for BOPIS
   * then it @returns - item availability information with the BOPIS only pickup
   * label
   * @return if the sku is resolved and the product is avialable only for BOSS
   * then it @returns - the boss dates information along with the BOSS only
   * pickup labels
   */
  getPickupInfo() {
    const {
      bopisItemInventory,
      userDefaultStore,
      productInfo,
      itemValues,
      isRadialInventoryEnabled,
    } = this.props;

    const isStoreBopisEligible = this.getIsStoreBopisEligible(bopisItemInventory);
    let isStoreBossEligible = true;
    if (userDefaultStore) {
      isStoreBossEligible = numericStringToBool(
        userDefaultStore.storeBossInfo && userDefaultStore.storeBossInfo.isBossEligible
      );
    }

    let isStoreAndProductBossEligible = this.getIsStoreAndProductBossEligible(isStoreBossEligible);
    // derive boss inventory from unbxd attribute v_qty_boss sepately RAD-74
    if (isRadialInventoryEnabled) {
      // kill switch RAD-171 RAD-74
      const isBOSSInventoryAvailable = !isBOSSProductOOS(productInfo.colorFitsSizesMap, itemValues);
      isStoreAndProductBossEligible = this.getIsStoreAndProductBossEligibleWithInventory(
        isBOSSInventoryAvailable,
        isStoreAndProductBossEligible
      );
    }
    return {
      showPickupDetails: this.pickupRenderCondition(isStoreAndProductBossEligible),
      isStoreBopisEligible,
      isStoreAndProductBossEligible,
    };
  }

  calculateBopisEligibility = (
    isStoreSpecialsPriceOn,
    storeSpecials,
    bopisValidatingParams,
    miscInfo,
    isDefaultBadge,
    shouldAllowOnlineProductPickup
  ) => {
    if ((isStoreSpecialsPriceOn && storeSpecials) || shouldAllowOnlineProductPickup) {
      return validateBopisEligibility({ ...bopisValidatingParams, miscInfo });
    }
    return validateBopisEligibility({ ...bopisValidatingParams, miscInfo }) && !isDefaultBadge;
  };

  handlePickUpScenarios = (prevProps) => {
    const { selectedAccessories, itemValues } = this.props;
    if (
      (prevProps.selectedAccessories !== selectedAccessories &&
        (prevProps?.itemValues?.Size?.name === '' ||
          prevProps?.itemValues?.Quantity !== itemValues?.Quantity)) ||
      (selectedAccessories && selectedAccessories.length > 0)
    ) {
      this.setState({ bopisWithAccessory: true });
    }

    if (
      prevProps?.itemValues?.Size !== itemValues?.Size ||
      (selectedAccessories && selectedAccessories?.length === 0)
    ) {
      this.setState({ bopisWithAccessory: false });
    }
  };

  shouldWeCallAPIToGetInventoryDetails = (prevProps, prevState) => {
    const {
      userDefaultStore,
      initialValues,
      itemValues,
      isAnchor,
      isNewReDesignFullfilmentSection,
      isBopisFilterOn,
    } = this.props;
    if (isNewReDesignFullfilmentSection) {
      if (isBopisFilterOn) {
        return this.shouldGetInventoryDetails(
          userDefaultStore,
          itemValues,
          prevProps,
          isAnchor,
          isNewReDesignFullfilmentSection,
          prevState
        );
      }
      return (
        this.shouldGetInventoryDetails(
          userDefaultStore,
          itemValues,
          prevProps,
          isAnchor,
          isNewReDesignFullfilmentSection,
          prevState
        ) && !isEqual(this.initialValues, initialValues)
      );
    }
    return this.shouldGetInventoryDetails(
      userDefaultStore,
      itemValues,
      prevProps,
      isAnchor,
      isNewReDesignFullfilmentSection
    );
  };

  pickupRenderCondition = (isStoreAndProductBossEligible) => {
    return this.isBopisEligible && isStoreAndProductBossEligible;
  };

  noBossBopisInfo = () => {
    return !this.isBopisEligible && !this.isBossEligible;
  };

  updateBossMultiStoreAnalyticsState = (prevProps) => {
    const { userDefaultStore, itemValues } = this.props;
    if (this.shouldTriggerBossAnalytics(userDefaultStore, itemValues, prevProps)) {
      this.setState({ isBossCalled: false });
    }
  };

  shouldTriggerBossAnalytics = (userDefaultStore, itemValues, prevProps) => {
    const { isPickUpSelected, isBopisMultipleStoreEnabled } = this.props;
    return (
      isBopisMultipleStoreEnabled &&
      isPickUpSelected === 'boss' &&
      this.isSkuResolved &&
      userDefaultStore &&
      itemValues.Size &&
      (itemValues.Size !== prevProps.itemValues.Size ||
        itemValues.color !== prevProps.itemValues.color ||
        isPickUpSelected !== prevProps.isPickUpSelected ||
        this.compareDefaultStore(prevProps))
    );
  };

  shouldGetInventoryDetails = (
    userDefaultStore,
    itemValues,
    prevProps,
    isAnchor,
    isNewReDesignFullfilmentSection
  ) => {
    const { isPickUpSelected, currentSelectedPickUpType, isBossBopisPDPSizeDrawer } = this.props;
    const bossBopis = isBossBopisPDPSizeDrawer
      ? prevProps.currentSelectedPickUpType !== currentSelectedPickUpType
      : prevProps.currentSelectedPickUpType === 'shipIt' &&
        currentSelectedPickUpType === 'pickItUp';
    return (
      isPickUpSelected !== 'home' &&
      isPickUpSelected !== 'boss' &&
      !isAnchor &&
      this.isSkuResolved &&
      userDefaultStore &&
      itemValues.Size &&
      ((isNewReDesignFullfilmentSection && bossBopis && itemValues.Size) ||
        itemValues.Size !== prevProps.itemValues.Size ||
        itemValues.color !== prevProps.itemValues.color ||
        isPickUpSelected !== prevProps.isPickUpSelected ||
        this.compareDefaultStore(prevProps))
    );
  };

  /**
   * @method compareDefaultStore
   * @description this method compares the value of userDefaultStore with the previous
   * and new value received.
   * @param {object} prevProps - the previous props receiving from the componentDidUpdate
   * @returns {true} If userDefaultStore exists and  prevProps.userDefaultStore
   * is null
   * @returns {true} If both prev and new userDefaultStore exists and the id of both stores
   * are different
   * @returns {false} if userDefaultStore doesn't exists
   *
   */
  compareDefaultStore(prevProps) {
    const { userDefaultStore } = this.props;
    if (userDefaultStore) {
      if (!prevProps.userDefaultStore) {
        return true;
      }
      if (
        prevProps.userDefaultStore &&
        userDefaultStore?.basicInfo?.id !== prevProps?.userDefaultStore?.basicInfo?.id
      ) {
        return true;
      }
    }
    return false;
  }

  isBagPackOptional = () => {
    const { accessoriesData } = this.props || {};
    const { customizationType } = accessoriesData || '';
    return customizationType !== 'mandatory';
  };

  getZipCode = (defaultStore) => {
    return (
      defaultStore &&
      defaultStore?.basicInfo &&
      defaultStore?.basicInfo?.address &&
      defaultStore?.basicInfo?.address?.zipCode
    );
  };

  fetchStorePayload = () => {
    const {
      userDefaultStore,
      cartItemsCount,
      mapboxStoreSearchTypesParam,
      isShoppingBag,
      isBopisMultipleStoreEnabled,
    } = this.props;

    const LATLONG_COOKIE = 'tcpGeoLoc';
    const distance = distancesMap[0]?.id;
    const country = getSiteId() && getSiteId().toUpperCase();
    const zipCode = this.getZipCode(userDefaultStore);
    const latLong = readCookie(LATLONG_COOKIE);
    let locationPromise = null;

    if (zipCode) {
      const addressFormData = {
        addressLocation: zipCode,
        distance: 25,
      };

      locationPromise =
        addressFormData &&
        getAddressLocationInfo(addressFormData?.addressLocation, mapboxStoreSearchTypesParam);
    } else if (latLong) {
      const [lat, long] = latLong.split('|');
      const geometry = {
        location: {
          lat,
          lng: long,
        },
      };
      locationPromise = Promise.resolve(geometry?.location);
    }

    return {
      distance,
      locationPromise,
      cartItemsCount,
      country,
      defaultStore: userDefaultStore,
      isCart: isShoppingBag,
      isBopisMultipleStoreEnabled,
    };
  };

  bossMultipleStoreCall = () => {
    const {
      productInfo,
      itemValues,
      getBopisStores,
      fromAvailableStoresClickMethod,
      isPickUpSelected,
    } = this.props;
    const itemPartNumber = getVariantId(
      productInfo.colorFitsSizesMap,
      itemValues.color,
      itemValues.Fit,
      itemValues.Size
    );
    const skuId = getSkuId(
      productInfo?.colorFitsSizesMap,
      itemValues.color,
      itemValues.Fit,
      itemValues.Size
    );
    const currentSizeEntry = getMapSliceForSize(
      productInfo.colorFitsSizesMap,
      itemValues.color,
      itemValues.Fit,
      itemValues.Size
    );
    const variantNo =
      currentSizeEntry && currentSizeEntry.variantNo ? currentSizeEntry.variantNo : null;
    const fetchPayload = this.fetchStorePayload();
    fromAvailableStoresClickMethod(true);
    fetchPayload.variantId = itemPartNumber;
    fetchPayload.variantNo = variantNo;
    fetchPayload.skuId = skuId;
    fetchPayload.quantity = itemValues?.Quantity;
    fetchPayload.nearestStoreUpdateFlag = true;
    fetchPayload.currentSelectedPickUpTypeOnPdp = isPickUpSelected;
    getBopisStores(fetchPayload);
  };

  getIsStoreBossBpoisEligibleFlags = ({ isVMPProduct, isVMPBossEligible, isVMPBOSSEnabled }) => {
    let { isBossEnabled } = this.props;
    let { isStoreAndProductBossEligible } = this.getPickupInfo();
    if (isVMPProduct) {
      isBossEnabled = isBossEnabled && this.isBossEligible;
    }

    if (isVMPBossEligible !== undefined && isVMPProduct && isVMPBOSSEnabled) {
      isStoreAndProductBossEligible = isVMPBossEligible;
    }
    return {
      isStoreAndProductBossEligible,
      isBossEnabled,
    };
  };

  getShowPickupInfo = ({ isRadialInventoryEnabled, productInfo, userDefaultStore, itemValues }) => {
    // RAD-74 Replace Outbound1 Inventory check to Outbound2(Radial/Boss Inventory)
    const validateBossOOS = isRadialInventoryEnabled ? isBOSSProductOOS : isProductOOS;
    const isbossInventoryAvailable = !validateBossOOS(productInfo.colorFitsSizesMap, itemValues);
    return !userDefaultStore || !this.isSkuResolved || isbossInventoryAvailable;
  };

  updateIsCalled = () => {
    this.setState({ isCalled: true });
  };

  updateIsBossCalled = () => {
    this.setState({ isBossCalled: true });
  };

  render() {
    const {
      userDefaultStore,
      userNearByStore,
      productInfo,
      isRadialInventoryEnabled,
      getBopisInventoryDetails,
      getStoreSpecificIventory,
      itemValues,
      bopisItemInventory,
      onPickUpOpenClick,
      simplifiedProductPickupView,
      isAnchor,
      sizeUnavailable,
      onPickupClickAddon,
      isOutfitVariant,
      keepAlive,
      outOfStockLabels,
      promotionalMessage,
      promotionalPLCCMessage,
      itemBrand,
      availableTCPmapNewStyleId,
      initialMultipackMapping,
      setInitialTCPStyleQty,
      isNewQVEnabled,
      currentColorEntry,
      productInfoFromBag,
      fromBagPage,
      pdpUrlFromBag,
      onCloseClick,
      pickupSelectionUpdate,
      isPickUpSelected,
      isNewReDesignFullfilmentSection,
      initialValues,
      noBossBopisInfoSendToPDP,
      isNewPDPEnabled,
      checkForOOSForVariant,
      miscInfo,
      alternateBrand,
      isAllSizeDisabled,
      isBopisEnabled,
      selectDeliveryType,
      isPDPBossBopisEnabled,
      currentSelectedPickUpType,
      trackClickAction,
      isFromPDP,
      navigation,
      selectedSizeValue,
      displayErrorMessage,
      resetSuggestedStores,
      updateFormValue,
      isBopisFilterOn,
      getProducts,
      onSubmit,
      formValues,
      isVMPBossEligible,
      isVMPBOSSEnabled,
      selectedAccessories,
      route,
      isPDP,
      trackClickAnalyticsBopisFilter,
      shippingMethodSelected,
      isShowShipToHomeEddEnabled,
      isNewPJPPDPRedesignEnabled,
      eddData,
      showSizeError,
      isBopisMultipleStoreEnabled,
      suggestedStores,
      nearestAvailableStore,
      fromAvailableStoresClickMethod,
      shouldShowSizeError,
      nearestAvailableStoreLoading,
      isBossMultipleStoreEnabled,
      defaultSuggestedStore,
      recommendationStores,
      isQuickView,
      recommendationsBopisInventory,
      partIdInfo,
      getAllNewMultiPack,
      multipackProduct,
      multiPackCount,
      isPickupPromotionPDPEnabled,
      showInStoreMsg,
      isDynamicFreeShippingEnabled,
      freeShippingThreshold,
      dynamicShippingCharge,
      isAllSizeDisableForBopisStore,
      showInStoreMessage,
      isDisplayPickupTimeEnabled,
      storeHoursThreshold,
      isFullDateDisplayEnabled,
      isBopisPromoDiscountBannerEnabled,
      isStoreSpecialsPriceOn,
      setMethod,
      storeSpecials,
      storeSpecialList,
      shouldAllowOnlineProductPickup,
      isFreeShippingOnFulfillmentTileEnabled,
    } = this.props;

    const { size } = initialValues;
    const { isVMPProduct } = miscInfo || {};
    noBossBopisInfoSendToPDP(this.noBossBopisInfo());
    if (this.noBossBopisInfo() && !isNewReDesignFullfilmentSection) {
      pickupSelectionUpdate('home');
      if (!isDynamicFreeShippingEnabled) {
        return null;
      }
    }
    this.isSkuResolved = validateSkuDetails(productInfo, itemValues);
    const { isSubmitting, bopisWithAccessory, isCalled, isBossCalled } = this.state;
    const theme = getTheme();
    const showPickupInfo = this.getShowPickupInfo({
      isRadialInventoryEnabled,
      productInfo,
      userDefaultStore,
      itemValues,
    });
    const { showChangeStore, pickupTitleText, isBossEligBossInvAvail } = this.setPickupTitle();
    const { showPickupDetails, isStoreBopisEligible } = this.getPickupInfo();

    const { isStoreAndProductBossEligible, isBossEnabled } = this.getIsStoreBossBpoisEligibleFlags({
      isVMPProduct,
      isVMPBossEligible,
      isVMPBOSSEnabled,
    });

    const isVariantsHasPreOrder = isVariantHasPreOrder(
      miscInfo?.variantPreOrderMap,
      isVMPBOSSEnabled
    );
    const isFromPDPPage = isPDP || isFromPDP;
    let isRecommendationsQV;
    if (isFromPDPPage) {
      isRecommendationsQV = this.checkRecommQV(
        isQuickView,
        isFromPDPPage,
        isBopisMultipleStoreEnabled
      );
    } else {
      isRecommendationsQV = this.checkRecommQV(
        isQuickView,
        this.checkPdpOnWeb(isFromPDPPage),
        isBopisMultipleStoreEnabled
      );
    }

    return (
      <ProductPickup
        isProductPickup
        shippingMethodSelected={
          isShowShipToHomeEddEnabled &&
          miscInfo &&
          !miscInfo?.preOrderDate &&
          !isVariantsHasPreOrder &&
          shippingMethodSelected
        }
        isVariantsHasPreOrder={isVariantsHasPreOrder}
        isShowShipToHomeEddEnabled={isShowShipToHomeEddEnabled}
        eddData={eddData}
        getBopisInventoryDetails={getBopisInventoryDetails}
        getStoreSpecificIventory={getStoreSpecificIventory}
        itemValues={itemValues}
        onPickUpOpenClick={onPickUpOpenClick}
        productInfo={productInfo}
        isSkuResolved={this.isSkuResolved}
        isBopisEligible={this.isBagPackOptional() && !bopisWithAccessory && this.isBopisEligible}
        isBossEligible={this.isBossEligible}
        showChangeStore={showChangeStore}
        pickupTitleText={pickupTitleText}
        userDefaultStore={userDefaultStore}
        userNearByStore={userNearByStore}
        isBossEligBossInvAvail={isBossEligBossInvAvail}
        bopisItemInventory={bopisItemInventory}
        isStoreBopisEligible={isStoreBopisEligible}
        showPickupDetails={showPickupDetails}
        showPickupInfo={showPickupInfo}
        isSubmitting={isSubmitting}
        simplifiedProductPickupView={simplifiedProductPickupView}
        isAnchor={isAnchor}
        sizeUnavailable={sizeUnavailable}
        onPickupClickAddon={onPickupClickAddon}
        isOutfitVariant={isOutfitVariant}
        isStoreAndProductBossEligible={isStoreAndProductBossEligible}
        keepAlive={keepAlive}
        outOfStockLabels={outOfStockLabels}
        promotionalMessage={promotionalMessage}
        promotionalPLCCMessage={promotionalPLCCMessage}
        itemBrand={itemBrand}
        availableTCPmapNewStyleId={availableTCPmapNewStyleId}
        initialMultipackMapping={initialMultipackMapping}
        setInitialTCPStyleQty={setInitialTCPStyleQty}
        isNewQVEnabled={isNewQVEnabled}
        currentColorEntry={currentColorEntry}
        productInfoFromBag={productInfoFromBag}
        fromBagPage={fromBagPage}
        pdpUrlFromBag={pdpUrlFromBag}
        onCloseClick={onCloseClick}
        pickupSelectionUpdate={pickupSelectionUpdate}
        isPickUpSelected={isPickUpSelected}
        isNewReDesignFullfilmentSection={isNewReDesignFullfilmentSection}
        noBossBopisInfo={this.noBossBopisInfo()}
        size={size}
        isNewPDPEnabled={isNewPDPEnabled}
        selectedPickUpType={selectDeliveryType}
        checkForOOSForVariant={checkForOOSForVariant}
        miscInfo={miscInfo}
        alternateBrand={alternateBrand}
        isAllSizeDisabled={isAllSizeDisabled}
        isBossEnabled={isBossEnabled}
        isBopisEnabled={bopisWithAccessory ? false : isBopisEnabled}
        isPDPBossBopisEnabled={isPDPBossBopisEnabled}
        currentSelectedPickUpType={currentSelectedPickUpType}
        trackClickAction={trackClickAction}
        isFromPDP={isFromPDP}
        navigation={navigation}
        selectedSizeValue={selectedSizeValue}
        displayErrorMessage={displayErrorMessage}
        defaultStore={JSON.parse(getLocalStorage('defaultStore')) || {}}
        resetSuggestedStores={resetSuggestedStores}
        updateFormValue={updateFormValue}
        isBopisFilterOn={isBopisFilterOn}
        getProducts={getProducts}
        onSubmit={onSubmit}
        formValues={formValues}
        bopisWithAccessory={bopisWithAccessory}
        isVMPBossEligible={isVMPBossEligible}
        selectedAccessories={selectedAccessories}
        route={route}
        theme={theme}
        isPDP={isPDP}
        trackClickAnalyticsBopisFilter={trackClickAnalyticsBopisFilter}
        isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
        showSizeMessageError={showSizeError}
        isBopisMultipleStoreEnabled={isBopisMultipleStoreEnabled}
        isBossMultipleStoreEnabled={isBossMultipleStoreEnabled}
        suggestedStores={suggestedStores}
        nearestAvailableStore={nearestAvailableStore}
        fromAvailableStoresClick={fromAvailableStoresClickMethod}
        shouldShowSizeError={shouldShowSizeError}
        nearestAvailableStoreLoading={nearestAvailableStoreLoading}
        bossMultipleStoreCall={this.bossMultipleStoreCall}
        isCalled={isCalled}
        updateIsCalled={this.updateIsCalled}
        isBossCalled={isBossCalled}
        updateIsBossCalled={this.updateIsBossCalled}
        defaultSuggestedStore={defaultSuggestedStore}
        recommendationStores={recommendationStores}
        isRecommendationsQV={isRecommendationsQV}
        isQuickView={isQuickView}
        recommendationsBopisInventory={recommendationsBopisInventory}
        partIdInfo={partIdInfo}
        getAllNewMultiPack={getAllNewMultiPack}
        multipackProduct={multipackProduct}
        multiPackCount={multiPackCount}
        isPickupPromotionPDPEnabled={isPickupPromotionPDPEnabled}
        showInStoreMsg={showInStoreMsg}
        isDynamicFreeShippingEnabled={isDynamicFreeShippingEnabled}
        freeShippingThreshold={freeShippingThreshold}
        dynamicShippingCharge={dynamicShippingCharge}
        isAllSizeDisableForBopisStore={isAllSizeDisableForBopisStore}
        showInStoreMessage={showInStoreMessage}
        isDisplayPickupTimeEnabled={isDisplayPickupTimeEnabled}
        storeHoursThreshold={storeHoursThreshold}
        isFullDateDisplayEnabled={isFullDateDisplayEnabled}
        isBopisPromoDiscountBannerEnabled={isBopisPromoDiscountBannerEnabled}
        isStoreSpecialsPriceOn={isStoreSpecialsPriceOn}
        setMethod={setMethod}
        storeSpecials={storeSpecials}
        storeSpecialList={storeSpecialList}
        shouldAllowOnlineProductPickup={shouldAllowOnlineProductPickup}
        isFreeShippingOnFulfillmentTileEnabled={isFreeShippingOnFulfillmentTileEnabled}
      />
    );
  }
}

function mapStateToProps(state, ownProps) {
  /*
   * Previously form values were tracked in the state of Product.jsx
   * This was causing unnecessary re-renders for the entire product card
   * Now using redux-form selector to pull the required values directly into
   * the components that need them
   */
  const { route } = ownProps;
  const isFBTEnabled = getIsFBTShowEnabled(state) || false;
  let formName = ownProps?.formName;
  const isQVModalOpen = getModalState(state);
  if (isFBTEnabled && isQVModalOpen) {
    const formNameSplit = ownProps?.formName?.split('-');
    formName = `${formNameSplit?.[0]}-QV-${formNameSplit?.[1]}`;
  }
  const selector = formValueSelector(formName);
  // creating new prop userDefaultStore which is a combination of
  //  favStore store or geo default store of user
  // TODO - use the favorite store and getGeoDefaultStore selector from store locator
  // const favStore = storesStoreView.getDefaultStore(state);
  // const geoDefaultStore = storesStoreView.getGeoDefaultStore(state);
  // const userDefaultStore = favStore || geoDefaultStore || null;
  // const offerEspot = generalStoreView.getEspotByName(state, 'fav_store_pickup_content');
  // const userDefaultStore = null;
  const userDefaultStore = PickupSelectors.getDefaultStore(state);
  const geoDefaultStore = PickupSelectors.getGeoDefaultStore(state);
  const nearByStore = getUserNearStore(state) || null;
  const changeSelectedStores = PickupSelectors.getChangedSelectedStore(state);
  let addressStore =
    JSON.parse(getLocalStorage('defaultStore')) ||
    userDefaultStore ||
    (nearByStore && nearByStore[0]) ||
    geoDefaultStore ||
    null;
  if (changeSelectedStores && changeSelectedStores?.basicInfo?.storeName) {
    addressStore = changeSelectedStores;
  }
  const defaultStore = addressStore;
  const fromBagPage = PickupModalSelectors.getIsPickupModalOpenFromBagPage(state);
  const fromChangeStore = PickupModalSelectors.getIsPickupModalOpenByCS(state);
  let isBopisFilterOn = false;
  const plpState = state.ProductListing;
  const slpState = state.SearchListingPage;
  if (route?.params?.isSearchListing) {
    isBopisFilterOn = slpState?.isBopisFilterOn;
  } else {
    isBopisFilterOn = plpState?.isBopisFilterOn;
  }
  return {
    itemValues: updateItemValueObj(selector(state, 'color', 'Fit', 'Size', 'Quantity')),
    pickupModalState: getIsPickupModalOpen(state),
    isBopisEnabled: getIsBopisEnabled(state),

    isBossEnabled: getIsBossEnabled(state),
    isBopisClearanceProductEnabled: PickupSelectors.getIsBopisClearanceProductEnabled(state),
    isBossClearanceProductEnabled: PickupSelectors.getIsBossClearanceProductEnabled(state),
    // isBopisEnabled: false,
    // isBossEnabled: false,
    // isBopisClearanceProductEnabled: false,
    // isBossClearanceProductEnabled: false,
    userDefaultStore: defaultStore,
    userNearByStore: nearByStore,

    userGeoCoordinates: {
      lat: null,
      long: null,
    },
    // TODO - these are required for default store.
    // Checking with BA since the requirement is not mentioned in the story.
    // TODO - check if required => userGeoCoordinates: userStoreView.getUserGeoCoordinates(state),
    // TODO - check if required => getGeoDefaultStore: storeOperators.storesOperator.loadDefaultStore,
    bopisItemInventory: PickupSelectors.getBopisItemInventory(state),
    // TODO - This changes to CMS data - offerEspotAvailable: offerEspot && offerEspot.value,
    // isRadialInventoryEnabled: PickupSelectors.getIsRadialInventoryEnabled(state),
    // TODO - dummy values for hardcoding the status. Remove once the API works.
    // bopisItemInventory: [
    //   {
    //     status: 'Limited availability',
    //     quantity: 10,
    //   },
    // ],
    isRadialInventoryEnabled: getIsRadialInventoryEnabled(state),
    isPDPBossBopisEnabled: PickupSelectors.getIsPDPBossBopisEnabled(state),
    selectedAccessories: getSelectedAccessories(state),
    onSubmit: submitProductListingFiltersForm,
    formValues: getFormValues('filter-form')(state),
    isVMPBOSSEnabled: getIsVMPBossEnabled(state),
    shippingMethodSelected: CheckoutSelector.getSavedShippingMethod(state),
    isShowShipToHomeEddEnabled: getIsShowShipToHomeEddEnabled(state),
    eddData: getEddData(state),
    isBopisMultipleStoreEnabled: getBopisMultipleStoreEnabled(state),
    isBossMultipleStoreEnabled: getBossMultipleStoreEnabled(state),
    cartItemsCount: PickupModalSelectors.getItemsCount(state),
    mapboxStoreSearchTypesParam: getStoreSearchTypesParam(state),
    suggestedStores: PickupModalSelectors.getSuggestedStores(state),
    nearestAvailableStore: PickupModalSelectors.getNearestAvailableStore(state),
    nearestAvailableStoreLoading: PickupModalSelectors.getNearestAvailableStoreLoading(state),
    isShoppingBag: fromBagPage && fromChangeStore,
    defaultSuggestedStore: PickupModalSelectors.getDefaultSuggestedStore(state),
    storeIdList: PickupModalSelectors.getStoresIDList(state),
    isQVModalOpen: getModalState(state),
    recommendationStores: PickupModalSelectors.getRecommendationStores(state),
    recommendationsBopisInventory: PickupSelectors.getRecommendationsBopisItemInventory(state),
    allBopisStores: PickupModalSelectors.getAllBopisStores(state),
    isPickupPromotionPDPEnabled: getIsPickupPromotionPDPEnabled(state),
    isDynamicFreeShippingEnabled: getIsDynamicFreeShippingEnabled(state),
    freeShippingThreshold: getFreeShippingThresholdValue(state),
    dynamicShippingCharge: getDynamicShippingCharge(state),
    isDisplayPickupTimeEnabled: getIsDisplayPickupTimeEnabled(state),
    storeHoursThreshold: getStoreHoursThreshold(state),
    isFullDateDisplayEnabled: getIsFullDateDisplayEnabled(state),
    isBopisPromoDiscountBannerEnabled: getIsBopisPromotionDiscountEnabled(state),
    isBopisFilterOn,
    isStoreSpecialsPriceOn: getShowBopisTileBasedOnStoreSpecials(state),
    storeSpecialList: PickupModalSelectors.getStoreSpecialList(state),
    shouldAllowOnlineProductPickup: allowOnlineProductPickup(state),
    isFreeShippingOnFulfillmentTileEnabled: getIsFreeShippingOnFulfillmentTileEnabled(state),
  };
}

const mapDispatchToProps = (dispatch) => ({
  getBopisInventoryDetails: (payload) => {
    dispatch(getBopisInventoryDetailsAction(payload));
  },
  getStoreSpecificIventory: (payload) => {
    dispatch(getStoreSpecificInventoryAction(payload));
  },
  onPickUpOpenClick: (payload) => {
    dispatch(openPickupModalWithValues(payload));
  },
  trackClickAction: (data) => {
    dispatch(trackClick(data));
  },
  resetSuggestedStores: (payload) => dispatch(resetStoresByCoordinates(payload)),
  updateFormValue: (field, value) => {
    dispatch(change('FindBopisStore', field, value));
  },
  getProducts: (payload) => {
    dispatch(getSlpProducts(payload));
  },
  trackClickAnalyticsBopisFilter: (payload) => {
    dispatch(setClickAnalyticsData(payload));
    const timer = setTimeout(() => {
      dispatch(trackClick(payload));
      clearTimeout(timer);
    }, 250);
  },
  getBopisStores: (payload) => {
    dispatch(getBopisStoresActn(payload));
  },
  fromAvailableStoresClickMethod: (payload) => {
    dispatch(fromAvailableStoresClick(payload));
  },
  setFromRecommQV: (payload) => {
    dispatch(setFromRecommQVActn(payload));
  },
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withSaga = withDynamicSaga([
  { key: 'ProductPickupStoreSaga', saga: ProductPickupStoreSaga },
  { key: 'PickUpStoreModalSaga', saga: PickupStoreModalSaga },
]);
const withReducer = withDynamicReducer({
  key: PRODUCT_PICKUP_REDUCER_KEY,
  reducer: ProductPickupReducer,
});
export default compose(withReducer, withSaga, withConnect)(ProductPickupContainer);
